import config from './config';
// Only use in main.js not SSR!
if (window.INITIAL_CONFIG) {
  config.initialize(window.INITIAL_CONFIG);
}
